var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldValidationPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_green",
    d: "M17.811 31.242l-1.817 1.817a1.159 1.159 0 01-1.638 0l-8.593-8.593a1.159 1.159 0 010-1.638l1.817-1.817a1.159 1.159 0 011.638 0l8.593 8.593a1.159 1.159 0 010 1.638z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_green",
    d: "M14.375 33.095l-1.806-1.806a1.167 1.167 0 010-1.649l19.604-19.604a1.167 1.167 0 011.649 0l1.806 1.806a1.167 1.167 0 010 1.649L16.024 33.095a1.167 1.167 0 01-1.649 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldValidationPositive);
export default __webpack_public_path__ + "static/media/fieldValidationPositive.896b8370bdfacc4b4c2aed66909cd2a4.svg";
export { ForwardRef as ReactComponent };